import {
	GET_ETHICGROUPS, GET_ETHICGROUPS_SUCCESS, GET_ETHICGROUPS_FAIL,
	GET_ETHICGROUPS_DETAILS, GET_ETHICGROUPS_DETAILS_SUCCESS, GET_ETHICGROUPS_DETAILS_FAIL,
	ETHICGROUP_CREATE, ETHICGROUP_CREATE_FAIL, ETHICGROUP_CREATE_SUCCESS,
	ETHICGROUP_DELETE, ETHICGROUP_DELETE_FAIL, ETHICGROUP_DELETE_SUCCESS,
	ETHICGROUP_UPDATE, ETHICGROUP_UPDATE_FAIL, ETHICGROUP_UPDATE_SUCCESS,RESET
} from "./actionTypes";

const initialState = {
	ethicGroupList: [],
	ethicGroup: {},
	postingResult: {},
	loading: false,
	loadingEthicGroupDetails: false,
	ethicGroupSetting:{},
	loadingethicGroupSetting: false,
	// loading: false,
	error: {
		message: "",
	},
	
};

const EthicGroupReducer = (state = initialState, action) => {
	if (!action)
		return state;
	switch (action.type) {
		case GET_ETHICGROUPS:
			state = { ...state, loading: false };
			break;
		case GET_ETHICGROUPS_SUCCESS:
			state = { ...state, ethicGroupList: action.payload, loading: false };
			break;
		case GET_ETHICGROUPS_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case GET_ETHICGROUPS_DETAILS:
			state = { ...state, loadingEthicGroupDetails: true };
			break;
		case GET_ETHICGROUPS_DETAILS_SUCCESS:
			state = { ...state, ethicGroup: action.payload, loadingEthicGroupDetails: false };
			break;
		case GET_ETHICGROUPS_DETAILS_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loadingEthicGroupDetails: false,
			};
			break;
		case ETHICGROUP_CREATE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case ETHICGROUP_CREATE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false,  };
			break;
		case ETHICGROUP_CREATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				postingResult: {},
				loading: false,
			};
			break;
		case ETHICGROUP_UPDATE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case ETHICGROUP_UPDATE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };
			break;
		case ETHICGROUP_UPDATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case ETHICGROUP_DELETE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case ETHICGROUP_DELETE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };
			break;
		case ETHICGROUP_DELETE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
			case RESET:
		state = { ...state, ethicGroup: {} };
			
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default EthicGroupReducer;